var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableColumnFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6875 18V13.3998C8.63607 10.6083 6.99486 7.8382 5 5.00029L19 5C16.8165 7.64347 15.3534 10.6224 13.3125 13.3998V18.0003L10.6875 18ZM11.9997 11.8135L15.456 6.86692H8.54348L11.9997 11.8135Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableColumnFilter);
export default __webpack_public_path__ + "static/media/table-column-filter.c1376406.svg";
export { ForwardRef as ReactComponent };